import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';

export class SimpleLayout extends Component {
    render() {
        return (
            <div>
                <Outlet />
            </div>
        )
    }
}
